import { FC } from 'react';

import * as S from './CardSkeleton.styles';

type CardSkeletonProps = { isMine?: boolean };

export const CardSkeleton: FC<CardSkeletonProps> = ({ isMine }) => {
  return (
    <S.CardWrapper data-testid="card-skeleton" $isMine={isMine}>
      <S.CardHeader>
        <S.CompanyInfo>
          <S.SkeletonCircle $size={35} />
          <S.SkeletonLine $maxWidth="99px" height={20} />
        </S.CompanyInfo>
      </S.CardHeader>

      <S.CardBody>
        <S.SkeletonLine height={10} />
        <S.SkeletonLine height={16} />
      </S.CardBody>

      <S.CardActions>
        {isMine && <S.PromoteButtonSkeleton />}

        <S.CardFooter>
          <S.SkeletonLine height={16} />
        </S.CardFooter>
      </S.CardActions>
    </S.CardWrapper>
  );
};
